import { InlineForm } from '@plone/volto/components';
import HomeBannerBody from '@arpav/components/ArpavTheme/Blocks/HomeBanner/HomeBannerBody';
import HomeBannerSchema from '@arpav/components/ArpavTheme/Blocks/HomeBanner/schema';
import { SidebarPortal } from '@plone/volto/components';
import { defineMessages } from 'react-intl';
import {
  getLivelliIdroData,
  getLivelliIdroFields,
} from '@arpav/components/ArpavTheme/Blocks/HomeBanner/layers/livelliIdroData';
import { useEffect, useState } from 'react';

const messages = defineMessages({
  newsInEvidence: {
    id: 'News in evidence',
    defaultMessage: 'News in evidence',
  },
});

export const schema = ({ intl }) => ({
  title: intl.formatMessage(messages.newsInEvidence),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage({ id: 'Default' }),
      fields: ['title', 'description'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage({ id: 'Title' }),
    },
    description: {
      title: intl.formatMessage({ id: 'Description' }),
      widget: 'textarea',
    },
  },
});

const tweakSchema = (schema, livelliIdroFields) => {
  schema.properties.livelliIdroMarker.schema.properties.markerField.choices = livelliIdroFields.map(
    n => [n, n]
  );
  return schema;
};

const Edit = props => {
  const { block, data, selected, onChangeBlock, intl } = props;
  const [livelliIdroFields, setLivelliIdroFields] = useState([]);

  useEffect(() => {
    if (!data.livelliIdroShow) return;
    getLivelliIdroData().then(items => setLivelliIdroFields(getLivelliIdroFields(items)));
  }, [data.livelliIdroShow]);

  const schema = tweakSchema(HomeBannerSchema({ intl }), livelliIdroFields);
  return (
    <div className="public-ui">
      <SidebarPortal selected={selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
        />
      </SidebarPortal>
      <HomeBannerBody {...props} isEditMode={true} />
    </div>
  );
};

export default Edit;
